import { ref } from "vue";
import { UploadBlobResult } from "@/shared/environment/blob/blob.types.ts";

const blobResult = ref<UploadBlobResult | undefined>();
const isPartRecognitionDialogOpen = ref<boolean>(false);

export const useHeaderSearch = () => {
    const setBlob = (blob: UploadBlobResult | undefined) => {
        blobResult.value = blob;
    };

    const setPartRecognitionDialog = (isOpen: boolean) => {
        isPartRecognitionDialogOpen.value = isOpen;
    };

    return {
        setBlob,
        setPartRecognitionDialog,
        blob: blobResult,
        isPartRecognitionDialogOpen,
    };
};
